import { useEffect, useState } from 'react'
import './style.css'
import { useTranslation } from 'react-i18next'
import CustomTreeItem from './CustomTreeItem'

const CustomTree = ({ tree, setFilters, filters, active, setActive }) => {
    const [openedList, setOpenedList] = useState([])
    const { t } = useTranslation('project')

    const handleClickItem = (key) => {
        return (event) => {
            event.stopPropagation()
            if (openedList.includes(key))
                setOpenedList(openedList.filter(el => el !== key))
            else
                setOpenedList([...openedList, key])
        }
    }

    const addActiveKey = (item, tempActive) => {
        if (item?.children?.length > 0) {
            item.children.forEach(child => {
                addActiveKey(child, tempActive)
            })
        } else {
            if (!active.includes(item.key))
                tempActive.push(item.key)
        }
    }

    const removeActiveKey = (item, tempActive) => {
        if (item?.children?.length > 0) {
            item.children.forEach(child => {
                removeActiveKey(child, tempActive)
            })
        } else {
            if (tempActive.indexOf(item.key) >= 0)
                tempActive.splice(tempActive.indexOf(item.key), 1)
        }
    }

    const manageActive = (item) => {
        const tempActive = [...active]
        if (checkStatus(item) === "") {
            addActiveKey(item, tempActive)
        } else {
            removeActiveKey(item, tempActive)
        }
        setActive(tempActive)
    }

    const handleSetType = (type) => {
        return (e) => {
            e.stopPropagation()
            manageActive(type)
        }
    }

    const checkStatus = (item) => {
        const statuses = []
        item?.children?.forEach(child => {
            return statuses.push(...checkChildStatus(child))
        })

        if (item?.children?.length > 0) {
            if (statuses.every(status => !status)) {
                return ''
            } else if (statuses?.every(status => status)) {
                return "tree_square_active"
            } else {
                return "tree_square_active_child"
            }
        } else {
            return active.includes(item.key) ? "tree_square_active" : ""
        }
    }

    const checkChildStatus = (child) => {
        const result = []
        if (child?.children?.length > 0) {
            child.children.forEach(c => {
                return result.push(...checkChildStatus(c))
            })
        } else {
            result.push(active?.includes(child.key))
        }
        return result
    }

    useEffect(() => {
        if (active?.length > 0) {
            setFilters({
                ...filters,
                reObjectFunctionTypeIds: active
            })
        } else {
            setFilters({
                ...filters,
                reObjectFunctionTypeIds: null
            })
        }
    }, [active])

    return (
        <div className='filters__ctree__wrapper'>
            <p className='filters__ctree__title'> {t('project:goal')}</p>
            <div className='filters__ctree'>
                {tree?.map((el, index) => {
                    return <CustomTreeItem
                        item={el}
                        key={index}
                        openedList={openedList}
                        active={active}
                        handleSetType={handleSetType}
                        handleClickItem={handleClickItem}
                        checkStatus={checkStatus}
                    />
                })}
            </div>
        </div>
    )
}

export default CustomTree